function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import Text from './Text';

var MinWeightPounds = 30;
var MaxWeightPounds = 600;

var WeightPounds = function (_Text) {
  _inherits(WeightPounds, _Text);

  function WeightPounds() {
    var _temp, _this, _ret;

    _classCallCheck(this, WeightPounds);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Text.call.apply(_Text, [this].concat(args))), _this), _this.isNumber = function (value) {
      return Boolean(value.match(/^\d+$/));
    }, _this.isValid = function (value) {
      if (!_this.isNumber(value)) {
        return false;
      }

      var pounds = Number(value);
      if (pounds < MinWeightPounds || pounds > MaxWeightPounds) {
        return false;
      }

      return true;
    }, _this.helpText = function (value) {
      if (_this.isValid(value)) {
        return '';
      }

      if (!_this.isNumber(value)) {
        return 'Please enter a round number for your weight (in pounds)';
      }

      return 'Please enter your weight in pounds (you entered ' + value + ' pounds)';
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return WeightPounds;
}(Text);

export default WeightPounds;


//////////////////
// WEBPACK FOOTER
// ./node_modules/bodyspec-form-builder/es/Fields/WeightPounds.js
// module id = 726
// module chunks = 0